var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPortraitWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 410.91391,
    height: 508.27148,
    viewBox: "0 0 410.91389 508.27148",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("colorProfile", {
    name: "Adobe RGB (1998)",
    xlinkHref: "data:application/vnd.iccprofile;base64,AAACVEFEQkUCEAAAbW50clJHQiBYWVogB88ABgADAAAAAAAAYWNzcEFQUEwAAAAAbm9uZQAAAAAAAAAAAAAAAAAAAAAAAPbWAAEAAAAA0y1BREJFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKY3BydAAAAPwAAAAyZGVzYwAAATAAAACQd3RwdAAAAcAAAAAUYmtwdAAAAdQAAAAUclRSQwAAAegAAAAOZ1RSQwAAAfgAAAAOYlRSQwAAAggAAAAOclhZWgAAAhgAAAAUZ1hZWgAAAiwAAAAUYlhZWgAAAkAAAAAUdGV4dAAAAABDb3B5cmlnaHQgMTk5OSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZAAAAGRlc2MAAAAAAAAAEUFkb2JlIFJHQiAoMTk5OCkAAAAAAAAAABEAQQBkAG8AYgBlACAAUgBHAEIAIAAoADEAOQA5ADgAKQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAADzUQABAAAAARbMWFlaIAAAAAAAAAAAAAAAAAAAAABjdXJ2AAAAAAAAAAECMwAAY3VydgAAAAAAAAABAjMAAGN1cnYAAAAAAAAAAQIzAABYWVogAAAAAAAAnBgAAE+lAAAE/FhZWiAAAAAAAAA0jQAAoCwAAA+VWFlaIAAAAAAAACYxAAAQLwAAvpw=",
    id: "color-profile1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-339.72221,-167.942)",
    id: "path30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-510.63181,-180.7262)",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-493.50101,-140.5651)",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-521.00392,-501.40641)",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z",
    transform: "translate(-523.12301,-509.35271)",
    id: "path50"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC1",
    transform: "translate(-367.31318,-113.33373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 0,0 c -8.085,-16.448 -15.668,-17.086 -18.782,-17.086 -12.407,0 -13.678,15.433 -4.686,32.214 C -8.518,43.027 9.327,37.627 11.976,30.497 11.307,27.569 6.882,13.999 0,0 M 67.519,5.53 C 54.116,-7.595 38.39,-17.449 31.315,-15.615 c -13.121,3.4 -3.931,39.928 -2.873,44.161 -1.498,5.872 -10.433,17.887 -27.772,17.887 -12.923,0 -30.117,-9.41 -40.403,-28.234 -9.87,-18.063 -9.914,-38.51 -1.493,-46.93 15.351,-15.351 43.122,-4.557 53.748,20.896 1.241,-8.111 3.783,-18.657 14.936,-18.657 11.051,0 28.39,12.667 43.133,28.205 2.106,2.22 -0.849,5.994 -3.072,3.817",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,452.96293,569.77867)",
    clipPath: "url(#clipPath30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 0,0 c -7.554,-4.599 -17.121,-8.333 -27.995,-8.333 -9.36,0 -19.343,2.079 -25.773,4.854 -15.645,-32.578 -32.504,-45.702 -33.073,-45.702 -6.603,-0.972 -13.187,3.531 -17.227,15.535 -2.036,6.051 -19.057,56.298 -19.057,56.298 0,0 6.162,8.88 15.727,8.88 20.9,0 12.826,-18.481 12.085,-28.911 -0.977,-13.728 3.65,-33.783 10.177,-36.625 2.002,0 20.132,22.863 20.132,39.776 -8.255,18.485 -5.678,36.888 4.943,36.888 8.752,0 12.239,-9.417 12.239,-16.568 0,-6.236 -1.168,-15.131 -3.199,-22.46 2.815,-2.145 14.358,-7.11 24.156,-7.11 9.259,0 17.593,3.3 24.503,7.573 C 3.216,7.543 4.532,2.759 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,680.8424,552.73307)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 0,0 c -3.224,5.136 3.206,15.4 15.326,22.66 2.55,-2.17 7.691,-6.499 8.947,-10.489 C 29.182,-3.412 4.626,-7.369 0,0 M 84.606,53.436 C 79.058,53.225 53.613,48.14 33.115,38.048 24.071,45.465 6.307,48.199 11.175,61.583 c 2.073,0 26.678,-1.544 26.678,11.772 0,0 -3.584,3.958 -13.281,3.958 -9.695,0 -29.596,-5.417 -29.596,-23.285 0,-14.482 8.956,-21.266 16.443,-27.96 C -1.234,18.42 -8.619,9.536 -8.619,1.305 c 0,-3.334 3.258,-12.798 21.09,-12.798 12.628,0 35.259,5.114 35.259,25.301 0,7.809 -6.536,16.01 -10.672,20.628 17.42,8.522 36.432,13.287 53.008,16.534 0,0 1.318,2.721 -5.46,2.466",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,658.00133,606.2812)",
    clipPath: "url(#clipPath34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC2",
    transform: "translate(-367.31318,-113.33373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M 0,0 72.618,-125.784 H 217.86 L 290.484,0 Z",
    style: {
      fill: "#ffd47c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,367.3132,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M 0,0 72.618,125.784 H 217.86 L 290.484,0 Z",
    style: {
      fill: "#fff2d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,367.3132,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 0,0 h 72.62 72.624 L 72.62,-125.784 36.307,-62.889 Z",
    style: {
      fill: "#ffc74f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.9668,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M 0,0 H 145.24 L 72.618,-125.784 Z",
    style: {
      fill: "#ffb500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,367.3132,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 0,0 -36.31,62.893 -36.313,62.891 H 72.62 L 36.31,62.893 Z",
    style: {
      fill: "#ffeabe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.97067,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 0,0 h -72.623 -72.617 l 72.617,125.784 z",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.9668,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "M 0,0 36.309,-62.892 H 108.93 L 145.241,0 Z",
    style: {
      fill: "#4bcacf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,464.14187,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M 0,0 36.309,62.892 H 108.93 L 145.241,0 Z",
    style: {
      fill: "#afe5e7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,464.14187,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M 0,0 H 36.31 72.621 L 36.31,-62.892 18.153,-31.444 Z",
    style: {
      fill: "#00b4c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.9688,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M 0,0 H 72.62 L 36.309,-62.892 Z",
    style: {
      fill: "#00a5ae",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,464.14187,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M 0,0 -18.155,31.447 -36.312,62.892 H 36.31 L 18.155,31.447 Z",
    style: {
      fill: "#8ddade",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.97067,285.97853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M 0,0 H -36.312 -72.62 l 36.308,62.892 z",
    style: {
      fill: "#00939f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,560.9688,285.97853)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC3",
    transform: "translate(-367.31318,-113.33373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M 0,0 H 2.051 C 3.002,0 3.735,0.172 4.249,0.517 4.763,0.861 5.021,1.378 5.021,2.068 5.021,2.451 4.949,2.773 4.808,3.036 4.665,3.298 4.469,3.512 4.216,3.676 3.965,3.84 3.658,3.96 3.298,4.037 2.937,4.113 2.538,4.152 2.1,4.152 H 0 Z M 0,-6.449 H -1.183 V 5.169 H 2.231 C 2.8,5.169 3.328,5.114 3.814,5.005 4.302,4.896 4.723,4.718 5.078,4.472 5.434,4.226 5.71,3.906 5.907,3.512 6.104,3.118 6.202,2.636 6.202,2.068 6.202,1.641 6.125,1.252 5.973,0.902 5.818,0.553 5.611,0.249 5.349,-0.008 5.087,-0.265 4.774,-0.471 4.413,-0.624 4.053,-0.777 3.658,-0.875 3.231,-0.919 l 3.398,-5.53 H 5.185 L 1.969,-1.018 H 0 Z",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,694.67187,125.15947)",
    clipPath: "url(#clipPath48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 0,0 c -4.734,0 -8.586,-3.852 -8.586,-8.586 0,-4.735 3.852,-8.586 8.586,-8.586 4.734,0 8.587,3.851 8.587,8.586 C 8.587,-3.852 4.734,0 0,0 m 0,-18.096 c -5.243,0 -9.51,4.266 -9.51,9.51 0,5.243 4.267,9.509 9.51,9.509 5.244,0 9.511,-4.266 9.511,-9.509 0,-5.244 -4.267,-9.51 -9.511,-9.51",
    style: {
      fill: "#ffa900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,697.49733,114.5644)",
    clipPath: "url(#clipPath50)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPortraitWhite);
export default __webpack_public_path__ + "static/media/logo-portrait-white.8fc6f50f1b5b5f145b115302030ccced.svg";
export { ForwardRef as ReactComponent };